import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Row,
  Form,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import CustomButton from "../../ui/custom-button";
import { toast } from "react-toastify";
import { getAllLectureConverter } from "../../api/api";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { MdTranscribe } from "react-icons/md";

const ffmpeg = new FFmpeg({ log: true });

const convertToMono = async (blob) => {
  try {
    await ffmpeg.load();
    await ffmpeg.writeFile("input.wav", await fetchFile(blob));
    await ffmpeg.exec(["-i", "input.wav", "-ac", "1", "output.wav"]);
    const data = await ffmpeg.readFile("output.wav");
    const monoBlob = new Blob([data.buffer], { type: "audio/wav" });
    return monoBlob;
  } catch (err) {
    //console.log(err);
    return new Blob();
  }
};

function UploadFileAudio() {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("bn");
  const [transcript, setTranscript] = useState("");
  const [translatedTranscript, setTranslatedTranscript] = useState("");
  //console.log("transcript", transcript);
  const [audioBlob, setAudioBlob] = useState(null);
  const [responseAudioBlob, setResponseAudioBlob] = useState(null);
  const [saving, setSaving] = useState(false);
  const user = useSelector((state) => state?.userInfo?.user);
  const [audiofiledata, setAudiofileData] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [lectures, setLectures] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    fetchLectureAnalysis();
  }, []);

  const fetchLectureAnalysis = async () => {
    try {
      const response = await getAllLectureConverter();
      if (response && response.data) {
        setLectures(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching lecture analysis:", error);
      toast.error("Failed to fetch lecture analysis data.");
    }
  };

  const handleAudioUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const monoBlob = await convertToMono(file);
    setAudioBlob(monoBlob);
    setisLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", monoBlob, "uploaded_audio.wav");
      formData.append("user_id", "665a3cfc6dd2f0d02f0a6b5e");
      formData.append("language", selectedLanguage);
      formData.append("voice", "male");

      const response = await axios.post(
        `https://us2.sourcesoftsolutions.com:8032/translate_lecture`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      //console.log("response", response);
      const result = response.data.file_name;
      setTranscript(response.data?.transcipt);
      setTranslatedTranscript(response.data?.translated_transcript);

      // Fetch the audio file blob from the returned file path
      try {
        const audioUrl = `https://us2.sourcesoftsolutions.com:8032/${result}`;
        const audioResponse = await fetch(audioUrl);
        const audioBlobFromServer = await audioResponse.blob();
        setResponseAudioBlob(audioBlobFromServer);
      } catch (fetchErr) {
        console.error("Error fetching audio blob from server:", fetchErr);
        setResponseAudioBlob(null);
      }

      setAudiofileData(result);
    } catch (error) {
      console.error("Error uploading audio:", error);
    } finally {
      setisLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    const formData = new FormData();
    formData.append("audio_file", audioBlob, "recording.wav");
    formData.append(
      "audio_response_file",
      responseAudioBlob,
      "output_audio_response.wav"
    );
    // formData.append("user_id", user?.id);
    formData.append("language", selectedLanguage);
    // formData.append("analysis", JSON.stringify(audiofiledata));
    // formData.append("refined_transcript", JSON.stringify(result?.refined_transcript));
    // //console.log(transcript);
    formData.append("transcript", transcript);
    formData.append("translated_transcript", translatedTranscript);
    // formData.append("dob", dob);
    // formData.append("patient_name", patient_name);
    // if (!user) return;

    try {
      await axios.post(
        `https://us2.sourcesoftsolutions.com:8006/audio-transcripts`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer test123securetoken`,
          },
        }
      );

      toast.success("Audio data saved successfully!");
      navigate("/lecture-convertor");
    } catch (error) {
      console.error("Error saving audio data:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="d-flex flex-column">
      <section className="py-2">
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="mb-4 shadow-sm">
                <Card.Body>
                  <div className="d-flex flex-column align-items-center">
                    <Card.Title
                      className="fw-bold mb-2"
                      style={{ fontSize: "1.5rem" }}
                    >
                      Upload Audio File
                    </Card.Title>
                    <Card.Text className="text-muted mb-4">
                      Select an audio file and preferred language to convert and
                      view transcript.
                    </Card.Text>
                    <Form.Group
                      controlId="languageSelect"
                      className="mb-3 w-100"
                      style={{ maxWidth: 350 }}
                    >
                      <Form.Label className="fw-semibold">Language</Form.Label>
                      <Form.Select
                        value={selectedLanguage}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                      >
                        <option value="bn">Bangla</option>
                        <option value="hi">Hindi</option>
                        <option value="or">Odia</option>
                      </Form.Select>
                    </Form.Group>
                    <div className="mb-3 w-100" style={{ maxWidth: 350 }}>
                      {isLoading ? (
                        <CustomButton disabled className="w-100">
                          <PulseLoader color="blue" size={10} />
                        </CustomButton>
                      ) : (
                        <>
                          <label
                            htmlFor="upload-audio"
                            className="btn btn-outline-primary w-100"
                          >
                            Select Audio File
                          </label>
                          <input
                            id="upload-audio"
                            type="file"
                            accept="audio/*"
                            className="d-none"
                            onChange={handleAudioUpload}
                          />
                        </>
                      )}
                    </div>
                    {audiofiledata && (
                      <div className="w-100 mt-3" style={{ maxWidth: 350 }}>
                        <audio
                          src={`https://us2.sourcesoftsolutions.com:8032/${audiofiledata}`}
                          controls
                          className="w-100"
                        />
                      </div>
                    )}
                  </div>
                </Card.Body>
                {(transcript || translatedTranscript) && (
                  <Card.Footer className="bg-light">
                    <Row>
                      <Col md={6}>
                        <div>
                          <strong>Transcript:</strong>
                          <div
                            className="border rounded p-2 mt-1"
                            style={{ minHeight: 60, background: "#f8f9fa" }}
                          >
                            {transcript ? (
                              transcript
                            ) : (
                              <span className="text-muted">
                                No transcript available.
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div>
                          <strong>Translated Transcript:</strong>
                          <div
                            className="border rounded p-2 mt-1"
                            style={{ minHeight: 60, background: "#f8f9fa" }}
                          >
                            {translatedTranscript ? (
                              translatedTranscript
                            ) : (
                              <span className="text-muted">
                                No translation available.
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card.Footer>
                )}
              </Card>
            </Col>
          </Row>
          {audiofiledata && audiofiledata.length !== 0 && (
            <Row className="justify-content-center mt-3">
              <Col md={8} className="d-flex justify-content-end">
                <CustomButton onClick={handleSave} className="px-4">
                  {saving ? <Spinner animation="border" size="sm" /> : "Save"}
                </CustomButton>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </div>
  );
}

export default UploadFileAudio;
